import { RULES_DEFAULTS } from 'settings/consultation-forms/consultationForms.const';

export const resolveConsultationFormRules = (rules) => {
  if (rules == null || typeof rules !== 'object' || Array.isArray(rules)) {
    return { ...RULES_DEFAULTS };
  }
  return { ...RULES_DEFAULTS, ...rules };
};
